<script lang="typescript">
    import type { LensVariant } from "./types";
    import type { LogoImage } from "./types";
    import { chevron, lensOptionDescription } from "./appData";
    import PriceDisplay from "./PriceDisplay.svelte";

    export let onButtonClick: () => void;
    export let variant: LensVariant;
    export let price: number;
    export let logo: LogoImage;

    let topImage: HTMLImageElement;

    const handleMouseEnter = () => {
        topImage.classList.add("opacity-0");
    };
    const handleMouseLeave = () => {
        topImage.classList.remove("opacity-0");
    };
</script>

<li on:mouseenter={handleMouseEnter} on:mouseleave={handleMouseLeave} on:click={onButtonClick}>
    <div
        class="w-40 h-full img-background relative"
        style={`background-image: url(${variant.image.after})`}
    >
        <img
            bind:this={topImage}
            src={variant.image.before}
            class="hide-on-hover w-full h-full object-cover rounded-full"
            alt="spectacle lens"
        />
    </div>
    <div class="flex flex-col justify-between w-full h-full ml-8">
        <div class="border-b border-gray-200 pb-1 flex justify-between items-end">
            {#if typeof logo !== "undefined"}
                <div class="font-medium text-3xl w-3/5">
                    <img src={logo.src} alt={logo.alt_text} class="w-3/5" />
                </div>
            {:else}
                <div class="font-medium text-3xl w-3/5">{variant.name}</div>
            {/if}
            <PriceDisplay {price}>
                <span slot="prefix" class="inline text-xl font-medium tracking-tighter">
                    from&nbsp;
                </span>
            </PriceDisplay>
        </div>
        <div class="mt-4 flex flex-row items-start justify-between h-full">
            <div class="w-2/3 h-full">
                <p>{lensOptionDescription[variant.optionType]}</p>
            </div>
            <button class="btn-primary btn-sm px-4" type="button" on:click={onButtonClick}>
                Learn more{@html chevron}
            </button>
        </div>
    </div>
</li>

<style>
    li {
        @apply items-start hover:shadow-md transition-shadow w-full;
        @apply bg-background flex px-8 py-8;
        cursor: pointer;
    }
</style>
